// var domain = 'http://121.43.232.50:8086';
var domain = 'http://p.douhuomall.com';
domain = '';
domain = 'http://localhost:8087';
// var domain = 'http://p.wiwibao.com';
if(process.env.NODE_ENV == 'production'){
    domain = '';
}
const base = {
	domain,
	url: domain + '/admin'
}
export default base